import { useState, useEffect, useRef, useContext } from "react";
import Logo from "../../assets/IEEPL-Logo.png";
import Logo_80w from "../../assets/IEEPL-Logo-80w.webp";
import Logo_160w from "../../assets/IEEPL-Logo-160w.webp";
import { useLocation } from "react-router-dom";
import "./nav.css";
import { Context } from "../../context/Context";

function Nav1() {
  const [isActive1, setIsActive1] = useState(false);
  const [isActive2, setIsActive2] = useState(false);
  const [isActive3, setIsActive3] = useState(false);
  const [isActive4, setIsActive4] = useState(false);

  const dropdownRef1 = useRef(null);
  const dropdownRef2 = useRef(null);
  const dropdownRef3 = useRef(null);
  const dropdownRef4 = useRef(null);

  const handleDropdownToggle1 = () => {
    setIsActive1(!isActive1);
    setIsActive2(false);
    setIsActive3(false);
    setIsActive4(false);
  };

  const handleDropdownToggle2 = () => {
    setIsActive2(!isActive2);
    setIsActive1(false);
    setIsActive3(false);
    setIsActive4(false);
  };

  const handleDropdownToggle3 = () => {
    setIsActive3(!isActive3);
    setIsActive1(false);
    setIsActive2(false);
    setIsActive4(false);
  };

  const handleDropdownToggle4 = () => {
    setIsActive4(!isActive4);
  };

  const location = useLocation();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setIsActive1(false);
      }

      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setIsActive2(false);
      }

      if (
        dropdownRef3.current &&
        !dropdownRef3.current.contains(event.target)
      ) {
        setIsActive3(false);
      }

      if (
        dropdownRef4.current &&
        !dropdownRef4.current.contains(event.target)
      ) {
        setIsActive4(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [hoveredLink, setHoveredLink] = useState(null);
  const [hoveredLink2, setHoveredLink2] = useState(null);
  const [hoveredLink3, setHoveredLink3] = useState(null);
  const [hoveredLink4, setHoveredLink4] = useState(null);
  const [isDropdownClicked, setIsDropdownClicked] = useState(false);
  console.log(hoveredLink, hoveredLink2, hoveredLink3, hoveredLink4, isDropdownClicked);

  const handleLinkHover = (index) => {
    setHoveredLink(index);
  };

  const handleLinkHover2 = (index) => {
    setHoveredLink2(index);
  };

  const handleLinkHover3 = (index) => {
    setHoveredLink3(index);
  };

  const handleLinkHover4 = (index) => {
    setHoveredLink4(index);
  };

  const handleDropdownClick = () => {
    setIsDropdownClicked(true);
  };
  //  For dynamic blog
  //  const user = false;
  const { user, dispatch } = useContext(Context);
  // const PF = `${import.meta.env.VITE_API_URL}/api/images/`;

  const handleLogout = () => {
    dispatch({ type: "LOGOUT" });
  };

  // end of dynamic blog
  return (
    <nav className="navbar sticky-top navbar-expand-lg navbar-light bg-light main-container">
      <div className="container-fluid">
        <a className="navbar-brand" href="/">
          <img
            src={Logo}
            srcSet={`${Logo_80w} 80w, ${Logo_160w} 160w`}
            sizes="63px"
            alt="IdeasLogo"
            width="63"
            height="63"
          />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse mx-auto"
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 mx-auto">
            {/* <li
              className={`nav-item dropdown dropdown-mega   ${
                location.pathname === "/about" ? "active-link" : ""
              }`}
            > */}

            {/* <li className=" nav-item dropdown">
                  <a
                    className=" nav-link dropdown-toggle "
                    href="/about"
                    id="DropdownMenuLink"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    
                  >
                   About Us
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="DropdownMenuLink"
                  >
                      <li
                          className={`  ${
                            location.pathname === "#AboutHero"
                              ? "active-link"
                              : ""
                          }`}
                        >
                          <a
                            className="dropdown-item"
                            href="/about"
                            onMouseEnter={() => handleLinkHover(0)}
                          >
                            Who We Are &#10095;
                          </a>
                        </li>
                        <li className="{`   ${location.pathname === '#directors' ? 'active-link' : ''}`}">
                          <a
                            className="dropdown-item"
                            href="/about#directors"
                            onClick={handleDropdownToggle1}
                            onMouseEnter={() => handleLinkHover(7)}
                          >
                            Directors &#10095;
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="/about#footprints"
                            onClick={handleDropdownToggle1}
                            onMouseEnter={() => handleLinkHover(8)}
                          >
                            Footprints &#10095;
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            href="/about#Awards"
                            onClick={handleDropdownToggle1}
                            onMouseEnter={() => handleLinkHover(9)}
                          >
                            Awards & Recognition &#10095;
                          </a>
                        </li>

                      
                        <li>
                          <a
                            className="dropdown-item"
                            href="/portfolio"
                            onClick={handleDropdownToggle1}
                            onMouseEnter={() => handleLinkHover(5)}
                          >
                            Benchmark &#10095;
                          </a>
                        </li>
                  </ul>
                </li> */}
            <li
              className={`nav-item nav-hover ${
                location.pathname === "/" ? "active-link" : ""
              }`}
            >
              <a className="nav-link " href="/">
                Home
              </a>
            </li>
            <li
              className={`nav-item dropdown dropdown-mega`}
              ref={dropdownRef1}
            >
              <a
                className={`nav-link dropdown-toggle ${
                  isActive1 ? "active" : ""
                }`}
                href="/about"
                id="megaMenu"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="true"
                onClick={(e) => {
                  e.preventDefault();
                  handleDropdownToggle1();
                }}
                onMouseDown={handleDropdownClick}
              >
                About Us
              </a>

              <ul
                className={`dropdown-menu shadow  ${isActive1 ? "show" : ""}`}
                aria-labelledby="megaMenu"
                data-bs-auto-close="outside"
              >
                <li
                  className={`links-1  ${
                    location.pathname === "#AboutHero" ? "active-link" : ""
                  }`}
                >
                  <a
                    className="dropdown-item"
                    href="/about#AboutHero"
                    onMouseEnter={() => handleLinkHover(0)}
                  >
                    Who We Are
                  </a>
                </li>
                <li
                  className={`${location.pathname === "#directors" ? "active-link" : ""}`}
                >
                  <a
                    className="dropdown-item"
                    href="/about#directors"
                    onClick={handleDropdownToggle1}
                    onMouseEnter={() => handleLinkHover(7)}
                  >
                    Directors
                  </a>
                </li>
                <li
                  className={`${location.pathname === "#our-teams" ? "active-link" : ""}`}
                >
                  <a
                    className="dropdown-item"
                    href="/about#our-teams"
                    onMouseEnter={() => handleLinkHover(8)}
                  >
                    Our Team
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/about#vision-mission"
                    onMouseEnter={() => handleLinkHover(9)}
                  >
                    Vision
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/about#corevalue"
                    onClick={handleDropdownToggle1}
                    onMouseEnter={() => handleLinkHover(10)}
                  >
                    Core Value
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/about#footprints"
                    onClick={handleDropdownToggle1}
                    onMouseEnter={() => handleLinkHover(11)}
                  >
                    Footprints
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/about#awards"
                    onClick={handleDropdownToggle1}
                    onMouseEnter={() => handleLinkHover(12)}
                  >
                    Awards & Recognition
                  </a>
                </li>

                <li>
                  <a
                    className="dropdown-item"
                    href="/portfolio"
                    onClick={handleDropdownToggle1}
                    onMouseEnter={() => handleLinkHover(13)}
                  >
                    Our Journey
                  </a>
                </li>
              </ul>
            </li>
            <li
              className={`nav-item dropdown dropdown-mega   ${
                location.pathname === "/Substation" ? "active-link" : ""
              }`}
              ref={dropdownRef2}
            >
              <a
                className={`nav-link dropdown-toggle ${
                  isActive2 ? "active" : ""
                }`}
                href="#"
                id="megaMenu2"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="true"
                onClick={handleDropdownToggle2}
                onMouseDown={handleDropdownClick}
              >
                Business Areas
              </a>

              <ul
                className={`dropdown-menu mega-menu shadow  ${
                  isActive2 ? "show" : ""
                }`}
                aria-labelledby="megaMenu2"
                data-bs-auto-close="outside"
              >
                <li>
                  <a
                    className="dropdown-item"
                    href="/Newsubstation"
                    onMouseEnter={() => handleLinkHover2(0)}
                  >
                    Substation
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/Transmisionline"
                    onMouseEnter={() => handleLinkHover2(2)}
                  >
                    Transmission Line
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/Scement"
                    onMouseEnter={() => handleLinkHover2(2)}
                  >
                    Cement
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/Ssolar"
                    onMouseEnter={() => handleLinkHover2(2)}
                  >
                    Solar
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/Electricle"
                    onMouseEnter={() => handleLinkHover2(4)}
                  >
                    Electrical & Instrumentation
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/EpcContacts"
                    onMouseEnter={() => handleLinkHover2(1)}
                  >
                    EPC Contracts
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/Cogen"
                    onMouseEnter={() => handleLinkHover2(5)}
                  >
                    Cogen & Sugar
                  </a>
                </li>

                {/* <li>
                        <a
                          className="dropdown-item"
                          href="/Panel"
                          onMouseEnter={() => handleLinkHover2(3)}
                        >
                          Panel Manufacturing
                        </a>
                      </li> */}
              </ul>
            </li>


            {/* Investors Relations */}
            <li
              className={`nav-item dropdown dropdown-mega  ${
                location.pathname === "/Environment" ? "active-link" : ""
              }`}
              ref={dropdownRef3}
            >
              <a
                className={`nav-link dropdown-toggle ${
                  isActive3 ? "active" : ""
                }`}
                href="#"
                id="megaMenu3"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="true"
                onClick={handleDropdownToggle3}
                onMouseDown={handleDropdownClick}
              >
                Investor Relations
              </a>

              <ul
                className={`dropdown-menu mega-menu shadow  ${
                  isActive3 ? "show" : ""
                }`}
                aria-labelledby="megaMenu3"
                data-bs-auto-close="outside"
              >
                <li className="dropdown-submenu" ref={dropdownRef4}>
                  <a
                    className={`dropdown-item dropdown-toggle submenu-toggle ${isActive4 ? "active" : ""}`}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDropdownToggle4();
                    }}
                    onMouseEnter={() => handleLinkHover3(0)}
                  >
                    Corporate Governance
                  </a>
                  <ul className={`dropdown-menu submenu shadow ${isActive4 ? "show" : ""}`}>
                    <li>
                      <a className="dropdown-item" href="/about#directors">
                        Board of Directors
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/board-committee">
                        Board Committees
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/corporate-profile">
                        Corporate Profile
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/Policies">
                        Policies
                      </a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="/Financials"
                    onMouseEnter={() => handleLinkHover3(0)}
                  >
                    Financials & Reports
                  </a>
                </li>
                 <li>
                  <a
                    className="dropdown-item"
                    href="/shareholding-pattern"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                    Shareholding Pattern
                  </a>
                </li>
                 <li>
                  <a
                    className="dropdown-item"
                    href="/stock-exchange-info"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                    Stock Exchange Information
                  </a>
                </li>
                 <li>
                  <a
                    className="dropdown-item"
                    href="/investor-analyst-meetings"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                    Investor / Analyst Meetings
                  </a>
                </li>
                 <li>
                  <a
                    className="dropdown-item"
                    href="/announcements-disclosure"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                   Announcements & Disclosure
                  </a>
                </li>
                 <li>
                  <a
                    className="dropdown-item"
                    href="/ipo-documents"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                   IPO / Prospectus Documents
                  </a>
                </li>
                 <li>
                  <a
                    className="dropdown-item"
                    href="/material-documents"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                   Material Documents / Contracts
                  </a>
                </li>
                 <li>
                  <a
                    className="dropdown-item"
                    href="/helpdesk"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                   Help Desk
                  </a>
                </li>
                 <li>
                  <a
                    className="dropdown-item"
                    href="/disclosure"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                   Regulation 46 of SEBI (LODR) 2015
                  </a>
                </li>

                
              </ul>
            </li>

            {/* <li
              className={`nav-item dropdown dropdown-mega  ${
                location.pathname === "/Environment" ? "active-link" : ""
              }`}
              ref={dropdownRef3}
            >
              <a
                className={`nav-link dropdown-toggle ${
                  isActive3 ? "active" : ""
                }`}
                href="#"
                id="megaMenu3"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="true"
                onClick={handleDropdownToggle3}
                onMouseDown={handleDropdownClick}
              >
                Investors
              </a>

              <ul
                className={`dropdown-menu mega-menu shadow  ${
                  isActive3 ? "show" : ""
                }`}
                aria-labelledby="megaMenu3"
                data-bs-auto-close="outside"
              >
                <li>
                  <a
                    className="dropdown-item"
                    href="/Financials"
                    onMouseEnter={() => handleLinkHover3(0)}
                  >
                    Financials
                  </a>
                </li>

                <li>
                  <a
                    className="dropdown-item"
                    href="/Policies"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                    Policies
                  </a>
                </li>
               <li>
                  <a
                    className="dropdown-item"
                    href="/GreenBuilding"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                    Sustainability
                  </a>
                </li>

                <li>
                  <a
                    className="dropdown-item"
                    href="/board-committee"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                    Board Committee
                  </a>
                </li>

                <li>
                  <a
                    className="dropdown-item"
                    href="/Csractivity"
                    onMouseEnter={() => handleLinkHover3(2)}
                  >
                    CSR Activities
                  </a>
                </li>
              </ul>
            </li> */}

            {/* <li
              className={`nav-item nav-hover ${
                location.pathname === "/projects" ? "active-link" : ""
              }`}
            >
              <a className="nav-link" aria-current="page" href="/projects">
                Projects
              </a>
            </li> */}
            {/* <li
              className={`nav-item dropdown dropdown-mega   ${
                location.pathname === "#" ? "active-link" : ""
              }`} ref={dropdownRef4}
            >
              <a
                className={`nav-link dropdown-toggle ${
                  isActive4 ? "active" : ""
                }`}
                href="#"
                id="megaMenu4"
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="true"
                onClick={handleDropdownToggle4}
                onMouseDown={handleDropdownClick}
              >
                 Projects
              </a>

              <ul
                className={`dropdown-menu mega-menu shadow  ${
                  isActive4 ? "show" : ""
                }`}
                aria-labelledby="megaMenu4"
                data-bs-auto-close="outside"
              >
               
                <li>
                  <a
                    className="dropdown-item"
                    href="/Completedprojects"
                    onMouseEnter={() => handleLinkHover4(0)}
                  >
                    Completed Projects &#10095;
                  </a>
                </li>

                <li>
                  <a
                    className="dropdown-item"
                    href="/OngoingProject"
                    onMouseEnter={() => handleLinkHover4(1)}
                  >
                    Ongoing Projects &#10095;
                  </a>
                </li>
                
              </ul>
            </li> */}
            <li
              className={`nav-item nav-hover ${
                location.pathname === "/OngoingProject" ? "active-link" : ""
              }`}
            >
              <a className="nav-link " href="/OngoingProject">
                Projects
              </a>
            </li>
            <li
              className={`nav-item nav-hover ${
                location.pathname === "/career" ? "active-link" : ""
              }`}
            >
              <a className="nav-link " href="/career">
                Career
              </a>
            </li>
            <li
              className={`nav-item nav-hover ${
                location.pathname === "/Media" ? "active-link" : ""
              }`}
            >
              <a className="nav-link " href="/Media">
                Media
              </a>
            </li>
            <li
              className={`nav-item nav-hover ${
                location.pathname === "/blogs" ? "active-link" : ""
              }`}
            >
              <a className="nav-link " href="/blogs">
                Blogs
              </a>
            </li>
            {/* <li
              className={`nav-item nav-hover ${
                location.pathname === "/blogs" ? "active-link" : ""
              }`}
            >
              <a className="nav-link " href="/write">
               Write
              </a>
            </li> */}
          </ul>
          {/* LOGIN AUTHENTIFICATION */}
          {user ? (
            <ul className="nav-login-wrapper">
            <li className={`nav-item nav-login dropdown`}>
              <a
                className={` dropdown-toggle `}
                href="#"
                id=""
                role="button"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-bs-auto-close="true"
              >
                Admin
                {/* <img className="topImg" src={PF+user.profilePic} alt="Ideas-img" /> */}
              </a>

              <ul
                className={`dropdown-menu shadow`}
                aria-labelledby=""
                data-bs-auto-close="outside"
              >
                {/* <li>
                <a
                  className="dropdown-item"
                  href="/Login"
                  
                >
                  Login 
                </a>
              </li> */}
                <li>
                  <a className="dropdown-item" href="/Dashboard">
                    Dashboard
                  </a>
                </li>
                {/* <li>
                <a
                  className="dropdown-item"
                  href="/Register"
                  
                >
                  Register &#10095;
                </a>
              </li> */}
                {/* <li>
                <a
                  className="dropdown-item"
                  href="/Write"
                  
                >
                  Add Blog &#10095;
                </a>
               
              </li> */}
                <li
                  className="dropdown-item topListItem"
                  onClick={handleLogout}
                >
                  {user && "Logout"}
                </li>
              </ul>
            </li>
            </ul>
          ) : (
            <ul className="topList">
              {/* <li className="topListItem">
          <a className="" href="/Login">
            LOGIN
          </a>
        </li>  */}
              {/* <li className="topListItem">
         <a className="" href="/register">
            REGISTER
          </a>
        </li> */}
            </ul>
          )}
          {/* END OF LOGIN AUTHENTIFICATION */}

          <ul className="navbar-nav">
          <li
            className={`nav-item  ${
              location.pathname === "/contacts" ? "active-link1" : ""
            }`}
          >
            <a className="nav-link " href="/contacts">
              CONTACT{" "}
              <span>
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.07317 1H15M15 1L1 15M15 1V11.9268"
                    stroke="#0091FF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            </a>
          </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Nav1;
